module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-WORDPRESS.7fc53c87.png";